// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1974ff83","453":"43b793bf","667":"f8ca2eca","977":"85d1854e"}[chunkId] + ".chunk.js";
};